import { sanitizeUrl } from '@braintree/sanitize-url';
import Link, { LinkProps } from 'next/link';
import React from 'react';
import { getPersistedParams } from 'utils/navigateUtils';
import { parseQueryString } from 'utils/urlUtils';

interface NextLinkProps extends LinkProps {
  className?: string;
  target?: string;
  children: React.ReactNode;
}

const NextLink = ({ ...props }: NextLinkProps) => {
  if (typeof props.href === 'string') {
    const urlParts = sanitizeUrl(props.href).split('?');
    const queryParams = parseQueryString(urlParts[1]);
    return (
      <Link
        {...props}
        legacyBehavior
        href={
          props.href.startsWith('#')
            ? props.href
            : { pathname: urlParts[0], query: { ...queryParams, ...getPersistedParams() } }
        }
      />
    );
  }
  if (typeof props.href.query !== 'string') {
    return (
      <Link
        {...props}
        legacyBehavior
        href={{
          ...props.href,
          pathname: props.href.pathname ? sanitizeUrl(props.href.pathname) : undefined,
          href: props.href.href ? sanitizeUrl(props.href.href) : undefined,
          query: { ...props.href.query, ...getPersistedParams() }
        }}
      />
    );
  }
  return <Link {...props} legacyBehavior />;
};

export default NextLink;
